export default "__VITE_ASSET__fa35c6ff__"